<template>
  <div
    class="fixed left-0 top-0 z-40 flex h-full max-h-full min-h-full w-full min-w-full items-center justify-center bg-black text-center"
    :class="bgOpacity"
  >
    <div
      class="mx-2 max-h-screen sm:m-0 sm:ml-20"
      :class="[
        $isMobile.value ? 'max-h-screen overflow-y-auto' : '',
        setWidth === '' ? 'max-w-full' : ` w-full ${setWidth}`,
      ]"
    >
      <div
        class=" z-50 my-2 overflow-hidden rounded-lg shadow "
        :class="[{'w-full': $isMobile.value}, {'max-h-screen overflow-y-auto' : !$isMobile.value}, maxWidth, bgColor]"
      >
        <div
          v-if="title !== ''"
          class=" relative overflow-hidden rounded-t-lg bg-gradient-to-br from-secondary-600 to-secondary-400 p-4 text-left text-white"
        >
          <div class="relative z-20 flex items-start justify-start">
            <div
              v-if="!$isMobile.value"
              ref="svgBit"
              class="mr-4"
              :class="{ 'h-0': !hasSvg, '': hasSvg }"
            >
              <slot name="svg" />
            </div>
            <div class="pr-24">
              <div class="brand-heading text-lg font-normal">
                {{ title }}
              </div>
              <div class="brand-body z-20 mt-1 text-sm font-normal tracking-tight text-gray-300">
                <div class="relative z-20">
                  {{ description }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="absolute bottom-0 right-0 -mb-16 mr-4 md:-mb-20">
          <img
            v-local-img="'players/1.png'"
            class="z-10 h-40 opacity-30 md:opacity-60"
            style="z-index: 10 !important"
          >
        </div>

        <button
          v-if="closeable"
          class="absolute right-0 top-0 z-30 m-4 text-white hover:text-gray-200 focus:outline-none"
          @click="$emit('close')"
        >
          <svg
            class="h-6 w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div
          class="max-w-full"
          :class="padding"
        >
          <slot name="content" />
          <div class="mt-5 sm:mt-4 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
            <span class="flex w-full shadow-sm sm:col-start-2">
              <slot name="primaryButton" />
            </span>
            <span class="mt-3 flex w-full sm:col-start-1 sm:mt-0">
              <slot name="secondaryButton" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalBase',

  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: String,
      default: 'max-w-3xl',
    },
    bgColor: {
      type: String,
      default: 'bg-white',
    },
    setWidth: {
      type: String,
      default: '',
    },
    padding: {
      type: String,
      default: 'p-4',
    },
    bgOpacity: {
      type: String,
      default: 'bg-opacity-30',
    },
    svgClasses: {
      type: String,
      default: 'mx-1 h-12 w-12 mt-1 fill-current text-brand-500',
    },
    closeable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hasSvg: false,
    };
  },

  mounted() {
    this.hasSvg = this.$refs.svgBit !== undefined && this.$refs.svgBit.children.length > 0;
    if (this.hasSvg) this.hackClassesIn();
  },

  methods: {
    hackClassesIn() {
      // eslint-disable-next-line no-restricted-syntax
      for (const item of this.$refs.svgBit.children) {
        const classes = this.svgClasses.split(' ');
        classes.forEach(
          (classIsAKeyword) => {
            item.classList.add(classIsAKeyword);
          },
        );
      }
    },
  },
};
</script>
